var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component, ProvideReactive, Watch } from 'vue-property-decorator';
import Year from './component/Calendar/Year.vue';
import Day from './component/Calendar/Day.vue';
import Month from './component/Calendar/Month.vue';
import { deepCopy } from '@lhb/func';
import Clipboard from 'clipboard';
import { getScheduleData, getShareScheduleUrl, exportSchedule } from '@views/schedule/api/index';
import Search from '../../components/Search/index.vue';
import eventLib from '@/common/utils/document-event';
import AlertModal from '../../components/AlertModal/index.vue';
import EditClueModal from '../../components/EditClueModal/index.vue';
import AddBoothModal from '@/layout/components/Navs/components/AddBoothModal.vue';
var targetUrl = require('config/env').targetUrl;
var isProd = process.env.NODE_ENV === 'production';
var ScheduleIndex = /** @class */ (function (_super) {
    __extends(ScheduleIndex, _super);
    function ScheduleIndex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entryData = {
            openEditClueModal: _this.openEditClueModal,
        };
        /* data */
        _this.searchParams = {
            period: 'DAY',
            boothIds: [],
            offset: 0,
            limit: 16,
        };
        _this.total = 0;
        _this.scheduleData = [];
        _this.loading = true;
        _this.shareUrl = '';
        _this.clipboard = null;
        _this.alertNum = 0;
        _this.sort = 0; // 当前选择的展位序列下标
        _this.meta = {
            placeNum: null,
            spotNum: null,
            hasOnlineSpot: null,
            modules: [] // 展位、广告位管理权限 tntSpotMng，advertisement
        };
        return _this;
    }
    Object.defineProperty(ScheduleIndex.prototype, "user", {
        get: function () {
            return this.$store.getters['getUserInfo'];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScheduleIndex.prototype, "currentCalendar", {
        get: function () {
            console.log("this.searchParams = ", this.searchParams.period);
            var schema = {
                'DAY': 'Day',
                'MONTH': 'Month',
                'YEAR': 'Year',
            };
            console.log("this.searchParams = ", schema[this.searchParams.period]);
            return schema[this.searchParams.period];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScheduleIndex.prototype, "addBoothKey", {
        get: function () {
            return this.$store.getters['getAddBoothKey'];
        },
        enumerable: false,
        configurable: true
    });
    ScheduleIndex.prototype.changeAddBoothKey = function (val) {
        if (val) {
            this.getData();
        }
    };
    ScheduleIndex.prototype.created = function () {
        this.$store.dispatch('$_UpdateUserInfo');
    };
    ScheduleIndex.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // 数据埋点
                window.LHBbigdata.send({
                    event_id: 'c9efd407-fe2a-41a5-a95d-3a31d8abe002',
                });
                eventLib.on('LOADING', function () {
                    _this.$refs.search && _this.$refs.search.loadData();
                });
                this.initClipboard();
                return [2 /*return*/];
            });
        });
    };
    ScheduleIndex.prototype.destroyed = function () {
        this.clipboard.destroy();
    };
    ScheduleIndex.prototype.loadmoreHandle = function () {
        this.searchParams.offset += this.searchParams.limit;
        this.pageLoading = true;
        this.getData();
    };
    ScheduleIndex.prototype.loadData = function (e) {
        this.cancelSelected();
        this.searchParams = __assign(__assign({}, e), { offset: 0, limit: 16 });
        this.getData();
    };
    ScheduleIndex.prototype.refreshHandle = function () {
        this.searchParams.offset = 0;
        this.getData();
        // 编辑线索的场景比较复杂，不适合静态跟新
        // const calendar = this.$refs.calendar;
        // calendar && calendar.refreshHandle(item, this.sort);
    };
    ScheduleIndex.prototype.getData = function () {
        var _this = this;
        this.loading = true;
        var params = deepCopy(this.searchParams);
        if (!params.statuses)
            delete params.statuses;
        if (!params.occupationStatus)
            delete params.occupationStatus;
        if (params.period === 'MONTH')
            params.period = 'DAY';
        if (params.period === 'YEAR') {
            delete params.startDate;
            delete params.endDate;
        }
        getScheduleData(params).then(function (_a) {
            var records = _a.records, total = _a.total, meta = _a.meta;
            _this.scheduleData = records === null || records === void 0 ? void 0 : records.map(function (e) { return (__assign(__assign({}, e), { shareLimit: e.allowShare ? e.shareLimit : 1 })); });
            _this.total = total;
            _this.meta = __assign({}, meta);
        }).catch(function () {
            _this.scheduleData = [];
            _this.total = 0;
            _this.meta = {
                placeNum: null,
                spotNum: null,
                hasOnlineSpot: null,
                modules: [] // 展位、广告位管理权限 tntSpotMng，advertisement
            };
        }).finally(function () {
            _this.pageLoading = false;
        });
    };
    ScheduleIndex.prototype.cancelSelected = function () {
        var calendar = this.$refs.calendar;
        calendar && calendar.cancelSelected();
    };
    ScheduleIndex.prototype.initClipboard = function () {
        var _this = this;
        if (this.clipboard)
            return;
        this.clipboard = new Clipboard('#copy');
        this.clipboard.on('success', function () {
            _this.$message({
                message: '已为您生成分享链接，可复制给需要的伙伴～',
                type: 'success',
            });
        });
        this.clipboard.on('error', function () {
            _this.$message({
                message: '该浏览器不支持自动复制!',
                type: 'warning',
            });
        });
    };
    // 到期提醒
    ScheduleIndex.prototype.alertHandle = function () {
        this.$refs.alertModal.init();
    };
    // 分享
    ScheduleIndex.prototype.shareHandle = function () {
        var _this = this;
        var params = deepCopy(this.searchParams);
        for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (!value) {
                delete params[key];
            }
            if (key === 'boothIds' && value.length > 0) {
                params[key] = value.split(',');
            }
        }
        params.offset = 0;
        params.limit = this.searchParams.offset + this.searchParams.limit;
        getShareScheduleUrl(params).then(function (res) {
            var baseUrl = isProd ? window.location.protocol + "//" + window.location.host + "/" : targetUrl;
            _this.shareUrl = baseUrl + "schedule/static?id=" + res.shareId;
            _this.$nextTick(function () {
                var btn = document.getElementById('copy');
                btn.click();
            });
        });
    };
    // 导出
    ScheduleIndex.prototype.exportHandle = function () {
        var _this = this;
        var loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        var params = deepCopy(this.searchParams);
        for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (!value) {
                delete params[key];
            }
        }
        exportSchedule(params).then(function (res) {
            window.open(res.url);
            _this.$message.success('导出成功～');
        }).finally(function () {
            loading.close();
        });
    };
    ScheduleIndex.prototype.openEditClueModal = function (id, sort) {
        this.sort = sort;
        this.$refs.editClueModal.init(id);
    };
    // 新建展位
    ScheduleIndex.prototype.addBoothHandle = function () {
        this.$router.push({
            path: 'lhb-micro-pms/pointMng'
        });
    };
    __decorate([
        ProvideReactive('schedule')
    ], ScheduleIndex.prototype, "entryData", void 0);
    __decorate([
        Watch('addBoothKey', {
            deep: true,
        })
    ], ScheduleIndex.prototype, "changeAddBoothKey", null);
    ScheduleIndex = __decorate([
        Component({
            components: {
                // Schedule
                Day: Day,
                Year: Year,
                Month: Month,
                Search: Search,
                EditClueModal: EditClueModal,
                AddBoothModal: AddBoothModal,
                AlertModal: AlertModal,
            },
        })
    ], ScheduleIndex);
    return ScheduleIndex;
}(Vue));
export default ScheduleIndex;
